import { render, staticRenderFns } from "./Paperform.vue?vue&type=template&id=fb359090&"
import script from "./Paperform.vue?vue&type=script&lang=js&"
export * from "./Paperform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports